import { atom } from "jotai";

export const plantillasAtom = atom([]);